module.exports = __webpack_public_path__ + "img/cartoon.daea14f2.png";